module.exports = __webpack_public_path__ + "img/calendarIcon.f4db7fe5.svg";